/*
 * @Author: 刘枫 
 * @Date: 2021-01-23 14:38:55 
 * @Last Modified by: 刘枫
 * @title: 银牌网店
 * @Last Modified time: 2021-01-23 15:05:51
 */

<template>
  <div id="new-shop-page">
    <div class="wrapper">
      <store-list></store-list>
    </div>
  </div>
</template>
<script>
import storeList from './good-shop';
export default {
  components: {
    storeList
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?c5d8047c